import React, { useMemo } from 'react';
import DataGrid from '../../common/DataGrid';

/**
 * Tax grid — column definitions only.
 * Before: 109 lines.  After: ~25 lines.
 */
export default function TaxGrid(props) {
  const columns = useMemo(
    () => [
      { field: 'tax_id', headerName: 'Tax Code/ID', maxWidth: 150, flex: 0 },
      {
        field: 'tax_rate',
        headerName: 'Rate (%)',
        valueFormatter: (params) => (params.value ? `${params.value}%` : '0%'),
        flex: 1,
      },
    ],
    []
  );

  return (
    <DataGrid
      {...props}
      columns={columns}
      exportFileName="tax_data.csv"
      isRowReadOnly={(row) => !!row.is_global}
      rowReadOnlyTitle="Shared tax code — managed globally and can't be edited per organisation."
    />
  );
}
